// Add public path
import '@/public-path.js';
import { createApp } from 'vue';
import App from './App.vue';
import commonFn from '@/commons/commonFunction.js';

const app = createApp(App);

//Add extension
import './commons/prototype';

// Globally Registered Components
import { useComponents } from '@/commons/globalComponents.js';
useComponents(app);

//phím tắt
import { shortKey } from '@/commons/directives/shortkey.js';
app.directive('shortkey', shortKey);

// Globally Registered Components
import { pluginInstall } from '@/commons/globalPlugin.js';
pluginInstall(app);

//Đăng ký popup
import { register } from '@/commons/globalPopup.js';
register(app);

//Đăng ký popover
import { registerPopover } from '@/commons/globalPopover.js';
registerPopover(app);

// filter
import { initFilter } from './commons/msFormat';
initFilter(app);

// Styles: SCSS
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import '@/assets/css/flexbox.css';
import '@/assets/css/common.css';
import '@/assets/scss/scroller.scss';
import '@/assets/scss/override.scss';
import '@/assets/scss/icons.scss';
import '@/assets/scss/form.scss';
import '@/assets/scss/function.scss';
import '@/assets/scss/app.scss';
import '@/assets/scss/main-style.scss';

app.config.productionTip = false;

// Vue.config.errorHandler = log.handleGlobalException;
if (process.env.NODE_ENV == 'development') {
  app.config.performance = true;
}

/**
 * directive xử lý style.visibility
 */
app.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

/**
 * directive tự động focus khi mounted
 */
app.directive('auto-focus', {
  mounted: (el, binding) => {
    // Truyền tham số là true để kích hoạt
    if (binding.value === true) {
      el.focus();
    }
  },
});
//Khai báo router
import router from '@/routers/router';
app.use(router);

//Khai báo store
import store from '@/stores/store';
app.use(store);

//Sử dụng localize
import i18n from '@/i18ns/i18n';
app.use(i18n);

// Provide để inject dùng trong setup (Xem tại PopupAddTask.vue)
import { I18nInjectionKey } from 'vue-i18n';
app.provide(
  I18nInjectionKey,
  app._context.provides[app.__VUE_I18N_SYMBOL__].global
);

import { PromiseDialog } from 'vue3-promise-dialog';
app.use(PromiseDialog);

import VueGridLayout from 'vue-grid-layout';
app.use(VueGridLayout);

import * as Sentry from '@sentry/vue';

// Thêm đoạn sau
if (process.env.NODE_ENV === 'production') {
  // Tùy vào cách lấy config của dự án
  Sentry.init({
    app,
    dsn: window._vite_sentry_dsn, // Đưa dsn vào biến môi trường hoặc dán thẳng
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.05,
    beforeSendTransaction: function (event) {
      const THRESHOLDS = {
        LCP: 2500,
        CLS: 0.1,
        INP: 200,
        FCP: 1000,
        TTFB: 300,
        CLICK_DELAY: 200,
        API_TIMEOUT: 3000,
      };

      const op = event?.contexts?.trace?.op;
      const measurements = event.measurements || {};

      // Tính Duration (ms)
      const start = event.start_timestamp || 0;
      const end = event.timestamp || 0;
      const duration = (end - start) * 1000;

      // ---  Xử lý Pageload & Navigation (Web Vitals) ---
      if (op === 'pageload' || op === 'navigation') {
        // Lấy các chỉ số (nếu không có thì mặc định là 0)
        const lcp = measurements['lcp']?.value || 0;
        const cls = measurements['cls']?.value || 0;
        const inp = measurements['inp']?.value || 0;
        const fcp = measurements['fcp']?.value || 0;
        const ttfb = measurements['ttfb']?.value || 0;

        // Kiểm tra xem có chỉ số nào vượt ngưỡng không
        const isBadExperience =
          lcp > THRESHOLDS.LCP ||
          cls > THRESHOLDS.CLS ||
          inp > THRESHOLDS.INP ||
          fcp > THRESHOLDS.FCP ||
          ttfb > THRESHOLDS.TTFB;

        if (isBadExperience) {
          return event;
        }

        if (Math.random() < 0.01) {
          if (event.spans) {
            event.spans = event.spans.filter(
              (span) => span.op === 'http.client' || span.op.startsWith('ui')
            );
          }

          return event;
        }

        return null;
      }

      // ---  Xử lý Tương tác (Click) ---
      if (op === 'ui.interaction.click' || op === 'ui.action') {
        if (duration > THRESHOLDS.CLICK_DELAY) {
          return event;
        }

        return null;
      }

      // ---  Xử lý API (Fetch/XHR) ---
      if (op === 'http.client') {
        const status = event.contexts?.response?.status_code;

        if ((status && status >= 400) || duration > THRESHOLDS.API_TIMEOUT) {
          return event;
        }

        return null;
      }

      return null;
    },
  });
}

async function initializeApp() {
  // kiểm tra authen -> lấy context
  await commonFn.initializeApp(app);
  //mount app
  app.mount('#app');
}

initializeApp();
